// src/components/Form/AlertForm.jsx
import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";
import EvidenceModal from "./EvidenceModal";
import FileManagementModal from "./FileManagementModal";
import Mapa from "../../modal/MapModal";
import NotificationModal from "./NotificationModal";
import { BusquedaVia } from "../Ubicacion";
import { useWeather } from "../../hooks/useWeather";
import "../../styles/form.css";

const AlertForm = ({
   latitude,
  longitude,
  address,
  setAddress,
  referencia,
  categorias,
  categoriaId,
  documento,
  handleChange,
  enviarDatos,
  markers,
  handleMarkerClick,
  handleAddMarker,
  loading,
  modoUbicacion = 'mapa',
  cambiarModoUbicacion,
  viaSeleccionada,
  onViaSeleccionada,
}) => {
  const [showMapModal, setShowMapModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({
    categoriaId: "",
    isAnonymous: false,
    documento: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    nombres: "",
    alias: "",
    genero: "",
    telefono: "",
    email: "",
    fecha: "",
    hora: "",
    comentario: "",
    fechaFin: "",
    horaFin: "",
    lunes: false,
    martes: false,
    miercoles: false,
    jueves: false,
    viernes: false,
    sabado: false,
    domingo: false,
    foto: null
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [categoriaError, setCategoriaError] = useState("");

  // Estados para los modales de evidencia
  const [showFileModal, setShowFileModal] = useState(false);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  
  // Estados para previews de diferentes tipos de archivos (solo para UI)
  const [previewVideo, setPreviewVideo] = useState(null);
  const [previewAudio, setPreviewAudio] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);

  // Estados para contadores de archivos
  const [fileCounts, setFileCounts] = useState({
    photos: 0,
    videos: 0,
    audio: 0,
    files: 0
  });

  // Estados para almacenar archivos por tipo
  const [mediaFiles, setMediaFiles] = useState({
    photos: [],
    videos: [],
    audio: [],
    files: []
  });

  // Estados para modales de gestión de archivos
  const [showPhotosModal, setShowPhotosModal] = useState(false);
  const [showVideosModal, setShowVideosModal] = useState(false);
  const [showAudioModal, setShowAudioModal] = useState(false);
  const [showAudioFilesModal, setShowAudioFilesModal] = useState(false);
  const [showFilesModal, setShowFilesModal] = useState(false);

  // Hook para obtener temperatura y clima
  const { temperature, weatherCode } = useWeather(latitude, longitude);

  const totalSteps = 5;

  const openMapModal = () => setShowMapModal(true);
  const closeMapModal = () => setShowMapModal(false);
  const openNotificationModal = () => setShowNotificationModal(true);
  const closeNotificationModal = () => setShowNotificationModal(false);

  // Funciones para manejar selección de ubicación
  const handleAddressSelect = (addressData) => {
    console.log("📍 handleAddressSelect llamado con:", addressData);
    // Actualizar la dirección y coordenadas cuando se selecciona desde el buscador
    if (addressData) {
      // Actualizar dirección directamente en el estado
      setAddress(addressData.address);
      
      // Actualizar coordenadas usando handleChange
      handleChange({
        target: {
          name: 'latitude',
          value: addressData.lat
        }
      });
      handleChange({
        target: {
          name: 'longitude',
          value: addressData.lng
        }
      });
      
      console.log("✅ Datos actualizados:", {
        address: addressData.address,
        lat: addressData.lat,
        lng: addressData.lng
      });
    }
  };

  const handleCoordinatesSelect = (lat, lng) => {
    console.log("📍 handleCoordinatesSelect llamado con:", lat, lng);
    // Actualizar coordenadas cuando se hace clic en el mapa
    handleChange({
      target: {
        name: 'latitude',
        value: lat
      }
    });
    handleChange({
      target: {
        name: 'longitude',
        value: lng
      }
    });
  };

  // Funciones para abrir modales de evidencia
  const openFileModal = () => setShowFileModal(true);
  const closeFileModal = () => setShowFileModal(false);
  const openPhotoModal = () => setShowPhotoModal(true);
  const closePhotoModal = () => setShowPhotoModal(false);
  const openVideoModal = () => setShowVideoModal(true);
  const closeVideoModal = () => setShowVideoModal(false);
  const openAudioModal = () => setShowAudioModal(true);
  const closeAudioModal = () => setShowAudioModal(false);

  // Función para agregar archivo y actualizar contador
  const addMediaFile = (file, type) => {
    console.log('📁 Agregando archivo:', file.name, 'tipo:', type);
    
    const newFile = {
      id: Date.now() + Math.random(),
      file: file,
      preview: URL.createObjectURL(file),
      name: file.name,
      size: file.size
    };

    console.log('📁 Nuevo archivo creado:', newFile);

    setMediaFiles(prev => {
      const updated = {
        ...prev,
        [type]: [...prev[type], newFile]
      };
      console.log('📁 Estado mediaFiles actualizado:', updated);
      return updated;
    });

    setFileCounts(prev => ({
      ...prev,
      [type]: prev[type] + 1
    }));

    // Si es foto, también actualizar formData.foto para el backend
    if (type === 'photos') {
      setFormData(prev => ({ ...prev, foto: file }));
    }
  };

  // Función para remover archivo
  const removeMediaFile = (fileId, type) => {
    setMediaFiles(prev => ({
      ...prev,
      [type]: prev[type].filter(f => f.id !== fileId)
    }));

    setFileCounts(prev => ({
      ...prev,
      [type]: prev[type] - 1
    }));

    // Si es foto y se remueve, limpiar formData.foto
    if (type === 'photos' && fileCounts.photos === 1) {
      setFormData(prev => ({ ...prev, foto: null }));
    }
  };

  // Función para limpiar todos los archivos de un tipo
  const clearMediaType = (type) => {
    setMediaFiles(prev => ({
      ...prev,
      [type]: []
    }));

    setFileCounts(prev => ({
      ...prev,
      [type]: 0
    }));

    // Si se limpian las fotos, limpiar formData.foto
    if (type === 'photos') {
      setFormData(prev => ({ ...prev, foto: null }));
    }
  };

  const handleMarkerSelect = (marker) => {
    handleMarkerClick(marker);
    closeMapModal();
  };

  const handleMarkerAddAndClose = (lat, lng) => {
    handleAddMarker(lat, lng);
    closeMapModal();
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({ ...prev, foto: file }));
      const reader = new FileReader();
      reader.onload = (e) => setPreviewImage(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const nextStep = async () => {
    // Validar categoría obligatoria
    if (currentStep === 1 && !categoriaId) {
      await Swal.fire({
        title: "Campo Requerido",
        text: "Debes seleccionar el tipo de incidencia para continuar",
        icon: "warning",
        confirmButtonText: "Entendido",
        confirmButtonColor: '#2c3e50',
        customClass: {
          popup: 'swal-popup-professional',
          confirmButton: 'swal-confirm-professional'
        }
      });
      return;
    }
    
    // Validar que se haya seleccionado el tipo de envío (anónimo o no)
    if (currentStep === 1 && !formData.isAnonymous && !documento) {
      await Swal.fire({
        title: "Selección Requerida",
        text: "Por favor selecciona si deseas enviar de forma anónima o con tus datos",
        icon: "warning",
        confirmButtonText: "Entendido",
        confirmButtonColor: '#2c3e50',
        customClass: {
          popup: 'swal-popup-professional',
          confirmButton: 'swal-confirm-professional'
        }
      });
      return;
    }

    // Validar campos personales obligatorios si no es anónimo (en paso 2)
    if (currentStep === 2 && !formData.isAnonymous && documento) {
      if (!formData.apellidoPaterno || !formData.apellidoMaterno || !formData.nombres || !formData.genero) {
        await Swal.fire({
          title: "Datos Personales Incompletos",
          text: "Para enviar con tus datos, debes completar: apellido paterno, materno, nombres y género",
          icon: "warning",
          confirmButtonText: "Entendido",
          confirmButtonColor: '#2c3e50',
          customClass: {
            popup: 'swal-popup-professional',
            confirmButton: 'swal-confirm-professional'
          }
        });
        return;
      }
    }

    // Validar alias obligatorio si es anónimo (en paso 2)
    if (currentStep === 2 && formData.isAnonymous) {
      if (!formData.alias || formData.alias.trim() === "") {
        await Swal.fire({
          title: "Alias Requerido",
          text: "Para enviar de forma anónima, debes ingresar un alias",
          icon: "warning",
          confirmButtonText: "Entendido",
          confirmButtonColor: '#2c3e50',
          customClass: {
            popup: 'swal-popup-professional',
            confirmButton: 'swal-confirm-professional'
          }
        });
        return;
      }
    }
    
    // Limpiar error de categoría si se seleccionó
    if (categoriaId) {
      setCategoriaError("");
    }
    
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSubmit = () => {
    // Verificar si el usuario tiene información de contacto para notificaciones
    const hasContactInfo = formData.email || formData.telefono;
    
    if (hasContactInfo) {
      // Abrir modal de confirmación de notificaciones
      openNotificationModal();
    } else {
      // Si no tiene contacto, enviar directamente
      submitFormData({});
    }
  };

  const submitFormData = (notificationPreferences) => {
    // Construir nombre completo si no es anónimo
    let nombreCompleto = "";
    if (!formData.isAnonymous) {
      const partes = [
        formData.apellidoPaterno,
        formData.apellidoMaterno,
        formData.nombres
      ].filter(parte => parte && parte.trim());
      nombreCompleto = partes.join(" ");
    }

    // Aquí puedes agregar validaciones adicionales
    const finalData = {
      ...formData,
      nombres: formData.isAnonymous ? (formData.alias || "Anónimo") : formData.nombres, // Alias para anónimos, nombres para identificados
      categoriaId,
      documento: formData.isAnonymous ? null : documento,
      latitude,
      longitude,
      address,
      referencia,
      notificationPreferences, // Agregar preferencias de notificación
      // Adjuntar todos los archivos capturados/seleccionados para subida posterior
      mediaFiles
    };
    
    console.log('📤 Datos finales a enviar:', finalData);
    console.log('📤 MediaFiles en finalData:', finalData.mediaFiles);
    
    // Cerrar modal de notificaciones si está abierto
    if (showNotificationModal) {
      closeNotificationModal();
    }
    
    enviarDatos(finalData);
  };

  // Función para limpiar el formulario
  const resetFormData = () => {
    setFormData({
      isAnonymous: false,
      apellidoPaterno: "",
      apellidoMaterno: "",
      nombres: "",
      alias: "",
      genero: "",
      telefono: "",
      email: "",
      fecha: "",
      hora: "",
      fechaFin: "",
      horaFin: "",
      comentario: "",
      lunes: false,
      martes: false,
      miercoles: false,
      jueves: false,
      viernes: false,
      sabado: false,
      domingo: false,
      foto: null
    });
    setPreviewImage(null);
    setCategoriaError("");
    setCurrentStep(1);
  };

  // Efecto para limpiar cuando cambie el documento (nuevo usuario)
  React.useEffect(() => {
    if (documento === "") {
      resetFormData();
    }
  }, [documento]);

  // Preparar opciones para react-select
  const categoriaOptions = Array.isArray(categorias) 
    ? categorias.map(categoria => ({
        value: categoria.cat_inId,
        label: categoria.cat_chNombre
      }))
    : [];

  const selectedCategoria = categoriaOptions.find(option => option.value === categoriaId);

  const handleCategoriaChange = (selectedOption) => {
    if (selectedOption) {
      handleChange({
        target: {
          name: 'categoriaId',
          value: selectedOption.value
        }
      });
      setCategoriaError("");
    } else {
      handleChange({
        target: {
          name: 'categoriaId',
          value: ""
        }
      });
    }
  };

  const renderProgressBar = () => (
    <div className="progress-container">
      <div className="progress-bar">
        <div 
          className="progress-fill" 
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        ></div>
      </div>
      <div className="step-indicators">
        {[1, 2, 3, 4, 5].map((step) => (
          <div 
            key={step}
            className={`step-indicator ${currentStep >= step ? 'active' : ''}`}
          >
            {step}
          </div>
        ))}
      </div>
    </div>
  );

  const renderStep1 = () => (
    <div className="step-content">
      <h3 className="step-title">Información Básica</h3>
      
      <div className="form-group">
        <label className="form-label">
          Tipo de Incidencia <span style={{ color: 'red' }}>*</span>
        </label>
        <Select
          value={selectedCategoria}
          onChange={handleCategoriaChange}
          options={categoriaOptions}
          placeholder={loading ? "Cargando categorías..." : "Selecciona una categoría"}
          isDisabled={loading}
          isClearable={false}
          isSearchable={true}
          className="react-select-container"
          classNamePrefix="react-select"
          styles={{
            control: (provided, state) => ({
              ...provided,
              borderColor: categoriaError ? '#dc3545' : provided.borderColor,
              boxShadow: categoriaError ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : provided.boxShadow,
              '&:hover': {
                borderColor: categoriaError ? '#dc3545' : provided.borderColor
              }
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 9999
            })
          }}
        />
        {categoriaError && (
          <small style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
            {categoriaError}
          </small>
        )}
        {loading && (
          <small style={{ color: '#666', fontStyle: 'italic' }}>
            Cargando categorías...
          </small>
        )}
      </div>

      <div className="form-group">
        <div className="checkbox-container">
          <input
            type="checkbox"
            id="anonymous"
            name="isAnonymous"
            checked={formData.isAnonymous}
            onChange={handleInputChange}
          />
          <label htmlFor="anonymous" className="checkbox-label">
            Enviar reporte anónimo
          </label>
        </div>
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div className="step-content">
      <h3 className="step-title">Datos Personales</h3>
      
      {!formData.isAnonymous && documento && (
        <>
          {/* Grid 2x2: Documento y Nombres */}
          <div className="form-row">
            <div className="form-group half-width">
              <label className="form-label">Documento (DNI)</label>
              <input
                type="text"
                className="form-input"
                value={documento}
                readOnly
                placeholder="Documento ingresado previamente"
              />
            </div>

            <div className="form-group half-width">
              <label className="form-label">
                Nombres <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                className="form-input"
                name="nombres"
                value={formData.nombres || ""}
                onChange={handleInputChange}
                placeholder="Ingresa tus nombres"
                required
              />
            </div>
          </div>

          {/* Grid 2x2: Apellido Paterno y Materno */}
          <div className="form-row">
            <div className="form-group half-width">
              <label className="form-label">
                Apellido Paterno <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                className="form-input"
                name="apellidoPaterno"
                value={formData.apellidoPaterno || ""}
                onChange={handleInputChange}
                placeholder="Ingresa tu apellido paterno"
                required
              />
            </div>

            <div className="form-group half-width">
              <label className="form-label">
                Apellido Materno <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                className="form-input"
                name="apellidoMaterno"
                value={formData.apellidoMaterno || ""}
                onChange={handleInputChange}
                placeholder="Ingresa tu apellido materno"
                required
              />
            </div>
          </div>

          {/* Grid 2x2: Género y Teléfono */}
          <div className="form-row">
            <div className="form-group half-width">
              <label className="form-label">
                Género <span style={{ color: 'red' }}>*</span>
              </label>
              <select
                className="form-input"
                name="genero"
                value={formData.genero || ""}
                onChange={handleInputChange}
                required
              >
                <option value="">Selecciona tu género</option>
                <option value="M">Masculino</option>
                <option value="F">Femenino</option>
              </select>
            </div>

            <div className="form-group half-width">
              <label className="form-label">
                Número de Teléfono
              </label>
              <input
                type="tel"
                className="form-input"
                name="telefono"
                value={formData.telefono || ""}
                onChange={handleInputChange}
                placeholder="Ej: 999888777"
              />
              <small style={{ color: '#666', fontStyle: 'italic' }}>
                Opcional - Para recibir notificaciones
              </small>
            </div>
          </div>

          {/* Grid 1x1: Email */}
          <div className="form-group">
            <label className="form-label">
              Correo Electrónico
            </label>
            <input
              type="email"
              className="form-input"
              name="email"
              value={formData.email || ""}
              onChange={handleInputChange}
              placeholder="ejemplo@correo.com"
            />
            <small style={{ color: '#666', fontStyle: 'italic' }}>
              Opcional - Para recibir notificaciones
            </small>
          </div>
        </>
      )}

      {formData.isAnonymous && (
        <>
          <div className="form-group">
            <label className="form-label">
              Alias <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="text"
              className="form-input"
              name="alias"
              value={formData.alias || ""}
              onChange={handleInputChange}
              placeholder="Ingresa un alias para tu reporte"
              required
            />
            <small style={{ color: '#666', fontStyle: 'italic' }}>
              Campo obligatorio para reportes anónimos
            </small>
          </div>

          {/* Grid 2x2: Teléfono y Email para anónimos */}
          <div className="form-row">
            <div className="form-group half-width">
              <label className="form-label">
                Número de Teléfono
              </label>
              <input
                type="tel"
                className="form-input"
                name="telefono"
                value={formData.telefono || ""}
                onChange={handleInputChange}
                placeholder="Ej: 999888777"
              />
            </div>

            <div className="form-group half-width">
              <label className="form-label">
                Correo Electrónico
              </label>
              <input
                type="email"
                className="form-input"
                name="email"
                value={formData.email || ""}
                onChange={handleInputChange}
                placeholder="ejemplo@correo.com"
              />
            </div>
          </div>

                     {/* Alerta para anónimos */}
           <div className="anonymous-info" style={{ 
             backgroundColor: '#e3f2fd', 
             border: '1px solid #2196f3', 
             borderRadius: '8px', 
             padding: '12px', 
             marginTop: '15px',
             textAlign: 'center'
           }}>
             <i className="fas fa-bell" style={{ color: '#2196f3', marginBottom: '8px', fontSize: '18px' }}></i>
             <p style={{ margin: '0', fontSize: '14px', color: '#1976d2', fontWeight: '500' }}>
               Agrega teléfono o correo para recibir notificaciones
             </p>
           </div>
          
                     <div className="anonymous-info" style={{ 
             backgroundColor: '#d4edda', 
             border: '1px solid #c3e6cb', 
             borderRadius: '8px', 
             padding: '12px', 
             marginTop: '15px',
             textAlign: 'center'
           }}>
             <i className="fas fa-user-secret" style={{ 
               fontSize: '18px', 
               color: '#155724', 
               marginBottom: '8px'
             }}></i>
             <p style={{ 
               margin: '0 0 5px 0', 
               color: '#155724', 
               fontSize: '14px',
               fontWeight: '600'
             }}>
               🛡️ Reporte Anónimo Seguro
             </p>
             <p style={{ 
               margin: '0', 
               color: '#155724', 
               fontSize: '13px'
             }}>
               El alias solo te identifica, no usa tus datos personales
             </p>
           </div>
        </>
      )}
    </div>
  );

  const renderStep3 = () => (
    <div className="step-content">
      <h3 className="step-title">Fecha y Hora del Incidente</h3>
      
      {/* Grid 2x2: Fecha Inicio y Fecha Fin */}
      <div className="form-row">
        <div className="form-group half-width">
          <label className="form-label">
            <i className="fas fa-calendar"></i>
            Fecha Inicio
          </label>
          <input
            type="date"
            name="fecha"
            className="form-input"
            value={formData.fecha}
            onChange={handleInputChange}
            max={new Date().toISOString().split('T')[0]}
          />
        </div>

        <div className="form-group half-width">
          <label className="form-label">
            <i className="fas fa-calendar-check"></i>
            Fecha Fin
          </label>
          <input
            type="date"
            name="fechaFin"
            className="form-input"
            value={formData.fechaFin}
            onChange={handleInputChange}
            min={formData.fecha || new Date().toISOString().split('T')[0]}
          />
        </div>
      </div>

      {/* Grid 2x2: Hora Inicio y Hora Fin */}
      <div className="form-row">
        <div className="form-group half-width">
          <label className="form-label">
            <i className="fas fa-clock"></i>
            Hora Inicio
          </label>
          <input
            type="time"
            name="hora"
            className="form-input"
            value={formData.hora}
            onChange={handleInputChange}
          />
        </div>

        <div className="form-group half-width">
          <label className="form-label">
            <i className="fas fa-clock"></i>
            Hora Fin
          </label>
          <input
            type="time"
            name="horaFin"
            className="form-input"
            value={formData.horaFin}
            onChange={handleInputChange}
          />
        </div>
      </div>

      {/* Grid 1x1: Comentario */}
      <div className="form-group">
        <label className="form-label">
          <i className="fas fa-comment-alt"></i>
          Comentario Adicional
        </label>
        <textarea
          name="comentario"
          className="form-textarea"
          value={formData.comentario}
          onChange={handleInputChange}
          placeholder="Describe brevemente lo ocurrido..."
          rows="4"
        />
      </div>

      {/* Grid 1x1: Días de la semana en una sola línea */}
      <div className="form-group">
        <label className="form-label">
          <i className="fas fa-calendar-week"></i>
          Días de la Semana
        </label>
        <div className="days-checkbox-container" style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '15px',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '10px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #dee2e6'
        }}>
          <div className="day-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              id="lunes"
              name="lunes"
              checked={formData.lunes}
              onChange={handleInputChange}
              style={{ marginRight: '5px' }}
            />
            <label htmlFor="lunes" style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>LUN</label>
          </div>

          <div className="day-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              id="martes"
              name="martes"
              checked={formData.martes}
              onChange={handleInputChange}
              style={{ marginRight: '5px' }}
            />
            <label htmlFor="martes" style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>MAR</label>
          </div>

          <div className="day-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              id="miercoles"
              name="miercoles"
              checked={formData.miercoles}
              onChange={handleInputChange}
              style={{ marginRight: '5px' }}
            />
            <label htmlFor="miercoles" style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>MIE</label>
          </div>

          <div className="day-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              id="jueves"
              name="jueves"
              checked={formData.jueves}
              onChange={handleInputChange}
              style={{ marginRight: '5px' }}
            />
            <label htmlFor="jueves" style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>JUE</label>
          </div>

          <div className="day-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              id="viernes"
              name="viernes"
              checked={formData.viernes}
              onChange={handleInputChange}
              style={{ marginRight: '5px' }}
            />
            <label htmlFor="viernes" style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>VIE</label>
          </div>

          <div className="day-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              id="sabado"
              name="sabado"
              checked={formData.sabado}
              onChange={handleInputChange}
              style={{ marginRight: '5px' }}
            />
            <label htmlFor="sabado" style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>SAB</label>
          </div>

          <div className="day-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              id="domingo"
              name="domingo"
              checked={formData.domingo}
              onChange={handleInputChange}
              style={{ marginRight: '5px' }}
            />
            <label htmlFor="domingo" style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>DOM</label>
          </div>
        </div>
        <small style={{ color: '#666', fontStyle: 'italic', marginTop: '5px' }}>
          Selecciona los días de la semana cuando ocurre este incidente
        </small>
      </div>
    </div>
  );

  const renderStep4 = () => (
    <div className="step-content">
      <h3 className="step-title">Evidencia Multimedia</h3>
      <div className="evidence-grid">
        <div className="evidence-card" onClick={openFileModal}>
          <div className="evidence-icon">
            <i className="fas fa-file-upload"></i>
          </div>
          <h4>Subir Archivo</h4>
          <p>Documentos desde galería o computadora</p>
        </div>
        <div className="evidence-card" onClick={openPhotoModal}>
          <div className="evidence-icon">
            <i className="fas fa-camera"></i>
          </div>
          <h4>Tomar Foto</h4>
          <p>Capturar imagen con cámara</p>
        </div>
        <div className="evidence-card" onClick={openVideoModal}>
          <div className="evidence-icon">
            <i className="fas fa-video"></i>
          </div>
          <h4>Grabar Video</h4>
          <p>Registrar video del incidente</p>
        </div>
        <div className="evidence-card" onClick={openAudioModal}>
          <div className="evidence-icon">
            <i className="fas fa-microphone"></i>
          </div>
          <h4>Grabar Audio</h4>
          <p>Registrar audio descriptivo</p>
        </div>
      </div>

      {/* Contadores de archivos */}
      {(fileCounts.photos > 0 || fileCounts.videos > 0 || fileCounts.audio > 0 || fileCounts.files > 0) && (
        <div className="evidence-summary">
          <h4 className="summary-title">Resumen de Evidencia</h4>
          <div className="file-counters">
            {fileCounts.photos > 0 && (
              <div className="counter-item" onClick={() => setShowPhotosModal(true)}>
                <div className="counter-icon photos">
                  <i className="fas fa-camera"></i>
                  <span className="counter-number">{fileCounts.photos}</span>
                </div>
                <span className="counter-label">Fotos</span>
              </div>
            )}
            {fileCounts.videos > 0 && (
              <div className="counter-item" onClick={() => setShowVideosModal(true)}>
                <div className="counter-icon videos">
                  <i className="fas fa-video"></i>
                  <span className="counter-number">{fileCounts.videos}</span>
                </div>
                <span className="counter-label">Videos</span>
              </div>
            )}
            {fileCounts.audio > 0 && (
              <div className="counter-item" onClick={() => setShowAudioFilesModal(true)}>
                <div className="counter-icon audio">
                  <i className="fas fa-microphone"></i>
                  <span className="counter-number">{fileCounts.audio}</span>
                </div>
                <span className="counter-label">Audio</span>
              </div>
            )}
            {fileCounts.files > 0 && (
              <div className="counter-item" onClick={() => setShowFilesModal(true)}>
                <div className="counter-icon files">
                  <i className="fas fa-file"></i>
                  <span className="counter-number">{fileCounts.files}</span>
                </div>
                <span className="counter-label">Archivos</span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Modales de gestión de archivos */}
      <FileManagementModal
        show={showPhotosModal}
        handleClose={() => setShowPhotosModal(false)}
        title="Gestión de Fotos"
        files={mediaFiles.photos}
        onRemoveFile={(fileId) => removeMediaFile(fileId, 'photos')}
        onClearAll={() => clearMediaType('photos')}
        fileType="photos"
      />
      <FileManagementModal
        show={showVideosModal}
        handleClose={() => setShowVideosModal(false)}
        title="Gestión de Videos"
        files={mediaFiles.videos}
        onRemoveFile={(fileId) => removeMediaFile(fileId, 'videos')}
        onClearAll={() => clearMediaType('videos')}
        fileType="videos"
      />
      <FileManagementModal
        show={showAudioFilesModal}
        handleClose={() => setShowAudioFilesModal(false)}
        title="Gestión de Audio"
        files={mediaFiles.audio}
        onRemoveFile={(fileId) => removeMediaFile(fileId, 'audio')}
        onClearAll={() => clearMediaType('audio')}
        fileType="audio"
      />
      <FileManagementModal
        show={showFilesModal}
        handleClose={() => setShowFilesModal(false)}
        title="Gestión de Archivos"
        files={mediaFiles.files}
        onRemoveFile={(fileId) => removeMediaFile(fileId, 'files')}
        onClearAll={() => clearMediaType('files')}
        fileType="files"
      />

      {/* Modales de captura */}
      <EvidenceModal
        show={showFileModal}
        handleClose={closeFileModal}
        title="Subir Archivo"
        type="file"
        onFileSelect={(file) => {
          addMediaFile(file, 'files');
          closeFileModal();
        }}
      />
      <EvidenceModal
        show={showPhotoModal}
        handleClose={closePhotoModal}
        title="Tomar Foto"
        type="photo"
        locationData={{ address, latitude, longitude, temperature, weatherCode }}
        onFileSelect={(file) => {
          addMediaFile(file, 'photos');
          closePhotoModal();
        }}
      />
      <EvidenceModal
        show={showVideoModal}
        handleClose={closeVideoModal}
        title="Grabar Video"
        type="video"
        onFileSelect={(file) => {
          addMediaFile(file, 'videos');
          closeVideoModal();
        }}
      />
      <EvidenceModal
        show={showAudioModal}
        handleClose={closeAudioModal}
        title="Grabar Audio"
        type="audio"
        onFileSelect={(file) => {
          addMediaFile(file, 'audio');
          closeAudioModal();
        }}
      />
    </div>
  );

const renderStep5 = () => (
    <div className="step-content">
      <h3 className="step-title">Ubicación del Incidente</h3>
      
      {/* Selector de modo de ubicación - Grid 2x2 para móvil */}
      <div className="ubicacion-mode-selector">
        <div className="mode-grid">
          <button
            type="button"
            className={`mode-btn ${modoUbicacion === 'mapa' ? 'active' : ''}`}
            onClick={() => cambiarModoUbicacion('mapa')}
            disabled={viaSeleccionada} // Deshabilitar si hay vía seleccionada
          >
            <i className="fas fa-map-marker-alt"></i>
            <span>Usar Mapa (GPS)</span>
          </button>
          <button
            type="button"
            className={`mode-btn ${modoUbicacion === 'via' ? 'active' : ''}`}
            onClick={() => cambiarModoUbicacion('via')}
            disabled={latitude && longitude} // Deshabilitar si hay coordenadas del mapa
          >
            <i className="fas fa-search"></i>
            <span>Buscar Vía Específica</span>
          </button>
        </div>
      </div>

      {/* Contenido según el modo seleccionado */}
      {modoUbicacion === 'mapa' ? (
        <>
          <div className="location-info">
            {latitude && longitude ? (
              <>
                <div className="coordinates">
                  <div className="coordinate-item">
                    <i className="fas fa-globe"></i>
                    <div>
                      <strong>Latitud:</strong> {latitude}
                    </div>
                  </div>
                  <div className="coordinate-item">
                    <i className="fas fa-globe"></i>
                    <div>
                      <strong>Longitud:</strong> {longitude}
                    </div>
                  </div>
                </div>
                
                {address && (
                  <div className="address">
                    <i className="fas fa-map-marker-alt"></i>
                    <div>
                      <strong>Dirección:</strong> {address}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="no-location">
                <i className="fas fa-map-marker-alt"></i>
                <p>Selecciona la ubicación en el mapa</p>
                <small>Puedes buscar una dirección o hacer clic en el mapa</small>
              </div>
            )}
          </div>

          <div className="form-group">
            <label className="form-label">Referencia Adicional</label>
            <textarea
              name="referencia"
              className="form-textarea"
              value={referencia}
              onChange={handleChange}
              placeholder="Ej: Frente al banco, cerca del semáforo, entre las calles X e Y..."
              rows="2"
            />
          </div>

          <div className="location-actions">
            <Button
              className="map-btn primary"
              onClick={openMapModal}
            >
              <i className="fas fa-map"></i>
              {latitude && longitude ? 'Cambiar Ubicación' : 'Seleccionar Ubicación'}
            </Button>
            
            {latitude && longitude && (
              <div className="location-status">
                <i className="fas fa-check-circle"></i>
                <span>Ubicación confirmada</span>
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          {/* Componente de búsqueda de vía optimizado para móvil */}
          <BusquedaVia
            onViaSeleccionada={onViaSeleccionada}
            modoUbicacion={modoUbicacion}
          />
        </>
      )}
    </div>
  );

  return (
    <div className="alert-form-wrapper">
      <div className="alert-form-container">
        {renderProgressBar()}
        
        <div className="form-content">
          {currentStep === 1 && renderStep1()}
          {currentStep === 2 && renderStep2()}
          {currentStep === 3 && renderStep3()}
          {currentStep === 4 && renderStep4()}
          {currentStep === 5 && renderStep5()}
        </div>

        <div className="form-navigation">
          {currentStep > 1 && (
            <button 
              className="nav-btn prev-btn"
              onClick={prevStep}
            >
              <i className="fas fa-chevron-left"></i>
              Anterior
            </button>
          )}

          {currentStep < totalSteps ? (
            <button 
              className="nav-btn next-btn"
              onClick={nextStep}
            >
              Siguiente
              <i className="fas fa-chevron-right"></i>
            </button>
          ) : (
            <button 
              className="submit-btn"
              onClick={handleSubmit}
              disabled={loading || (modoUbicacion === 'mapa' && (!latitude || !longitude)) || (modoUbicacion === 'via' && !viaSeleccionada)}
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Enviando...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane"></i>
                  Enviar Alerta
                </>
              )}
            </button>
          )}
        </div>
      </div>

      {/* Modal del Mapa */}
      <Mapa
        show={showMapModal}
        handleClose={closeMapModal}
        markers={markers}
        handleMarkerClick={handleMarkerSelect}
        handleAddMarker={handleMarkerAddAndClose}
        onAddressSelect={handleAddressSelect}
        onCoordinatesSelect={handleCoordinatesSelect}
      />
      
      {/* Modal para Subir Archivo */}
      <EvidenceModal
        show={showFileModal}
        handleClose={closeFileModal}
        title="Subir Archivo"
        type="file"
        onFileSelect={(file) => {
          addMediaFile(file, 'files');
          closeFileModal();
        }}
      />
      
             {/* Modal para Tomar Foto */}
       <EvidenceModal
         show={showPhotoModal}
         handleClose={closePhotoModal}
         title="Tomar Foto"
         type="photo"
         locationData={{ address, latitude, longitude, temperature, weatherCode }}
         onFileSelect={(file) => {
           addMediaFile(file, 'photos');
           closePhotoModal();
         }}
       />
      
      {/* Modal para Grabar Video */}
      <EvidenceModal
        show={showVideoModal}
        handleClose={closeVideoModal}
        title="Grabar Video"
        type="video"
        onFileSelect={(file) => {
          addMediaFile(file, 'videos');
          closeVideoModal();
        }}
      />
      
      {/* Modal para Grabar Audio */}
      <EvidenceModal
        show={showAudioModal}
        handleClose={closeAudioModal}
        title="Grabar Audio"
        type="audio"
        onFileSelect={(file) => {
          addMediaFile(file, 'audio');
          closeAudioModal();
        }}
      />

      {/* Modal de Confirmación de Notificaciones */}
      <NotificationModal
        show={showNotificationModal}
        handleClose={closeNotificationModal}
        onConfirm={submitFormData}
        userEmail={formData.email}
        userPhone={formData.telefono}
        loading={loading}
      />
    </div>
  );
};

export default AlertForm;